<template>
  <div class="auto-login-page">
    <ReLoading v-if="isLoading" />
    <div v-else-if="errorMessage" class="auto-login-page__message">
      <h2>Não conseguimos acessar sua conta</h2>
      <p>{{ errorMessage }}</p>
      <p v-if="redirecting" class="auto-login-page__redirect-message">
        Estamos redirecionando você para a tela de login
      </p>
    </div>
  </div>
</template>

<script>
import ReLoading from "@/components/re-loading/ReLoading.vue";
import api from "@/services/api";

const FALLBACK_COMPANY_LABEL = "recrutei-empregos";

export default {
  name: "AutoLogin",
  components: { ReLoading },
  data: () => ({
    isLoading: true,
    redirecting: false,
    errorMessage: null
  }),
  computed: {
    token() {
      return this.$route.params.token;
    }
  },
  created() {
    this.autoLogin();
  },
  methods: {
    async autoLogin() {
      if (!this.token) {
        this.handleError("Token inválido.");
        return;
      }

      this.isLoading = true;
      this.errorMessage = null;

      try {
        const response = await api.get(`/api/v1/auth/auto-login/${this.token}`, {
          headers: {
            "x-api-key": process.env.VUE_APP_API_KEY
          }
        });

        const data = response && response.data ? response.data : {};
        const accessToken = data.access_token;
        const redirectUrl = data.redirect_url;

        if (!accessToken) {
          this.handleError("Não foi possível validar o token.");
          return;
        }

        localStorage.setItem("userToken", accessToken);

        this.redirectToTarget(redirectUrl);
      } catch (error) {
        this.handleError("Não foi possível concluir o login automático.");
      } finally {
        if (!this.redirecting) {
          this.isLoading = false;
        }
      }
    },
    redirectToTarget(url) {
      this.redirecting = true;
      if (url) {
        window.location.replace(url);
        return;
      }

      this.$router.replace({
        name: "dashboard-info",
        params: { company_label: FALLBACK_COMPANY_LABEL }
      });
    },
    handleError(message) {
      this.errorMessage = message;
      this.isLoading = false;
      this.redirecting = true;

      setTimeout(() => {
        this.$router.replace({
          name: "signin",
          params: { company_label: FALLBACK_COMPANY_LABEL }
        });
      }, 5000);
    }
  }
};
</script>

<style scoped lang="scss">
.auto-login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  background: #f5f7fb;
  text-align: center;
}

.auto-login-page__message {
  max-width: 480px;
}

.auto-login-page__redirect-message {
  margin-top: 1rem;
  color: #666;
  font-style: italic;
}

</style>

